import { ColorGray200, FontSize100, FontSize300, SpaceMd, ColorTextDefault } from "@nxt-costco-com/forge-design-tokens";
import { responsiveStyles } from "../responsiveStyles.js";
import { newShade } from "./lib.js";
const containerStyles = {
  alignItems: "center",
  display: "flex",
  flex: "1 0 0",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%"
};
const linkStyles = {
  alignItems: "center",
  color: ColorTextDefault,
  display: "flex",
  flexDirection: "column",
  margin: "2px 0",
  padding: `0 ${SpaceMd}`
};
const titleStyles = {
  fontSize: { md: FontSize300, xs: FontSize100 },
  fontStretch: "100%",
  textAlign: "center",
  wordBreak: "normal"
};
const getBkgCircleStyles = (backgroundColor = ColorGray200) => {
  const bkgCircleStyles = {
    "&:hover": {
      backgroundColor: newShade(backgroundColor, -21)
    },
    backgroundColor,
    borderRadius: "50%",
    display: "inline-block",
    transition: "all 0.3s linear",
    ...responsiveStyles
  };
  return { bkgCircleStyles };
};
const imageStyles = {
  "&:hover": {
    transform: "translate(0px, -5px)"
  },
  "@media (prefers-reduced-motion)": {
    transform: "none !important"
  },
  margin: "auto",
  maxWidth: "100%",
  transition: "all 0.3s linear",
  ...responsiveStyles
};
const defaultSxObj = {
  containerStyles,
  imageStyles,
  linkStyles,
  titleStyles
};
export {
  defaultSxObj,
  getBkgCircleStyles
};
